module.exports = __webpack_public_path__ + "static/media/Uniben.e015c578.png";